export const buttonHeight: { [key: string]: string } = {
  xs: '28px',
  sm: '36px',
  md: '40px',
  lg: '44px',
  xl: '48px',
  '2xl': '56px',
};

export const buttonPadding: { [key: string]: string } = {
  xs: '12px',
  sm: '12px',
  md: '16px',
  lg: '16px',
  xl: '20px',
  '2xl': '20px',
};

export const iconPadding: { [key: string]: string } = {
  xxs: '4px',
  xs: '8px',
  sm: '8px',
  md: '10px',
  lg: '12px',
  xl: '14px',
  '2xl': '16px',
};

export const buttonFontSize: { [key: string]: string } = {
  xs: '14px',
  sm: '14px',
  md: '14px',
  lg: '14px',
  xl: '16px',
  '2xl': '20px',
};

export const buttonLineHeight: { [key: string]: number } = {
  xs: 1.43,
  sm: 1.43,
  md: 1.43,
  lg: 1.43,
  xl: 1.5,
  '2xl': 1.4,
};
